import {ICellRendererParams} from "@ag-grid-community/core";
import {ServiceBadge} from "../ServiceBadge";

const ServiceTypeCellRenderer = (props: ICellRendererParams<any, string>) => {
  return <ServiceBadge service={props.value} ellipsize></ServiceBadge>;
};

export default ServiceTypeCellRenderer;
